import { render, staticRenderFns } from "./flowDetails.vue?vue&type=template&id=01bc13e4&"
import script from "./flowDetails.vue?vue&type=script&lang=js&"
export * from "./flowDetails.vue?vue&type=script&lang=js&"
import style0 from "./flowDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports